import Query from "./query";

class GetDistance extends Query {
    constructor() {
        super("getDistance");
    }

    async execute(params) {
        const position1 = new THREE.Vector3(...params[0]);
        const position2 = new THREE.Vector3(...params[1]);
        return (position1.distanceTo(position2));
    }
}

export default GetDistance;